var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDownload(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 9,
    height: 10,
    viewBox: "0 0 9 10",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.707031 6.4248V8.08381C0.707031 8.33524 0.806078 8.57637 0.982381 8.75415C1.15869 8.93194 1.64714 9.03182 1.64714 9.03182H7.28776C7.53709 9.03182 7.77621 8.93194 7.95251 8.75415C8.12882 8.57637 8.22786 8.33524 8.22786 8.08381V6.4248",
    stroke: "#32325A",
    strokeWidth: 0.895337,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M4.359 1.41093V6.78296M4.359 6.78296L6.50781 4.73033M4.359 6.78296L2.21022 4.73033",
    stroke: "#32325A",
    strokeWidth: 0.895337,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownload);
export default __webpack_public_path__ + "static/media/download.d26d9c19acefa9757124858a391d0f69.svg";
export { ForwardRef as ReactComponent };